import { Component, Inject, OnInit } from '@angular/core';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { AuthService } from 'src/app/modules/home/services/auth.service';
import { EmailVerifiedSuccessfullyComponent } from '../email-verified-successfully/email-verified-successfully.component';
import { EmailVerifyFailComponent } from '../email-verify-fail/email-verify-fail.component';

@Component({
  selector: 'app-signup-successfully',
  templateUrl: './signup-successfully.component.html',
  styleUrls: ['./signup-successfully.component.scss']
})
export class SignupSuccessfullyComponent implements OnInit {

  constructor(
    private _dialogRef: MatDialogRef<SignupSuccessfullyComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _dialog: MatDialog,
    private authService:AuthService
  ) { }

  ngOnInit(): void {
     console.log("thhhh",this.data);
  }
  dialogClose() {
    // this._dialogRef.close();
    document.getElementsByClassName("animate__animated")[0].classList.remove("animate__fadeInDown")
    document.getElementsByClassName("animate__animated")[0].classList.add("animate__fadeOutUp"); 
    setTimeout(() => { this._dialogRef.close(); }, 1000);
  }
  emailVerifiedSuccessfully(){
    this._dialog.open ( EmailVerifiedSuccessfullyComponent, {
      width: '30%',
      panelClass: ['custom-modal', 'animate__animated', 'animate__fadeInDown'],
      disableClose: true,
    })
  }


  isVeryfy(){

    console.log(this.data)
     this.authService.getUer(this.data.id).subscribe(data=>{
          console.log(data)
          if(data.lead_verified === true){
            this._dialog.open ( EmailVerifiedSuccessfullyComponent, {
              width: '30%',
              panelClass: 'custom-modal'
            })
          }else{
            this._dialog.open ( EmailVerifyFailComponent, {
              width: '30%',
              panelClass: 'custom-modal'
            })
          }
        })

  }
}
